import { RootPageLayout } from '@components/root-page-layout';
import { GuideChecklist } from './guide-checklist';
import { Resources } from './resources';
import { CreateWidget } from './create-widget';
import { RUZUKU_ASSETS_BASE_URL } from 'shared/consts';
import { useCurrentUser } from 'client/lib/auth';
import { defCoursesRoute } from '@course/components/courses-app-router';

function Page() {
  const user = useCurrentUser();

  return (
    <RootPageLayout activeTab="welcome" title="Welcome!" hideTitle>
      <div class="flex items-center justify-between bg-linear-to-b from-gray-100 to-indigo-50 rounded-2xl px-8 py-8 text-gray-900 mb-8 relative">
        <div>
          <h2 class="text-3xl font-semibold tracking-tight mb-2">👋 Welcome, {user?.name}!</h2>
        </div>
        <img
          class="hidden lg:block absolute right-8 w-48 h-48"
          data-attribution="https://undraw.co"
          src={`${RUZUKU_ASSETS_BASE_URL}/undraw_welcoming_re_x0qo.svg`}
        />
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 mb-4 lg:mb-8">
        <GuideChecklist />
        <Resources />
      </div>
      <CreateWidget />
    </RootPageLayout>
  );
}

export const route = defCoursesRoute({
  Page,
  authLevel: 'guide',
});
